export interface NavigationMenuItem {
  menuTitle: string;
  iconPath?: string;
  url?: string;
}

export const navigationConfig = {
  coachee: {
    myProfile: {
      menuTitle: 'Profile',
      url: '/coachee-profile/update-profile',
      iconPath: '/icons/profile-icon.svg',
    },
    mcqAffinity: {
      menuTitle: 'QCM Affinité',
      url: '/coachee/mcq-affinity',
      iconPath: '/assets/icons/mcq-icon.svg',
    },
    myCoach: {
      menuTitle: 'Mon Coach',
      url: '/coachee/my-coach',
      iconPath: '/assets/icons/coach-icon.svg',
    },
    myAvailability: {
      menuTitle: 'Mes Dispos',
      url: '/coachee/my-availability',
      iconPath: '/assets/icons/availability-icon.svg',
    },
    help: {
      menuTitle: 'Aide',
      url: '/coachee/help',
      iconPath: '/assets/icons/help-icon.svg',
    },
  },
  coach: {
    myProfile: {
      menuTitle: 'Profil',
      url: '/coach/profile',
      iconPath: '/assets/icons/profile-icon.svg',
    },
    mycoachees: {
      menuTitle: 'Mes Coachings',
      url: '/coach/my-coachees',
      iconPath: '/assets/icons/coach-icon.svg',
    },
    myAvailability: {
      menuTitle: 'Mes Disponibilités',
      url: '/coach/my-availability',
      iconPath: '/assets/icons/availability-icon.svg',
    },
    announcements: {
      menuTitle: 'Annonces',
      url: '/coach/announcements',
    },
    help: {
      menuTitle: 'Aide',
      url: '/coach/help',
      iconPath: '/assets/icons/help-icon.svg',
    },
  },
} satisfies Record<string, Record<string, NavigationMenuItem>>;
